import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React from "react";
import { css } from "styled-components";

const enum fields {
    horizontalGap = "horizontalGap",
    isFullWidth = "isFullWidth",
}

interface Props extends WidgetProps {
    fields: {
        [fields.horizontalGap]: number;
        [fields.isFullWidth]: boolean;
    };
}

export interface TwoColumnFieldContainer {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const twoColumnFieldContainerStyles: TwoColumnFieldContainer = {
    gridContainer: {
        offsetCss: css`
            margin-top: 0;
            margin-bottom: 0;
        `,
    },
    gridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

const styles = twoColumnFieldContainerStyles;

const TwoColumnFieldContainer = ({ id, fields: { horizontalGap, isFullWidth } }: Props) => {
    return (
        <GridContainer gap={horizontalGap} isFullWidth={isFullWidth} {...styles.gridContainer}>
            <GridItem {...styles.gridItem}>
                <Zone zoneName="TwoColumnFieldContainer_Left" contentId={id} />
            </GridItem>
            <GridItem {...styles.gridItem}>
                <Zone zoneName="TwoColumnFieldContainer_Right" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: TwoColumnFieldContainer,
    definition: {
        group: "Contact Us",
        displayName: "Two Column Field Container",
        icon: "box",
        fieldDefinitions: [
            {
                name: fields.horizontalGap,
                displayName: "Horizontal Gap Between Items",
                editorTemplate: "IntegerField",
                defaultValue: 20,
                fieldType: "General",
                max: 1000,
                min: 0,
            },
            {
                name: fields.isFullWidth,
                displayName: "Full Width",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
